import Firebase from "./Firebase";
import { getDatabase, ref, set, remove, update } from "firebase/database";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { invalidateDemoData } from "./databaseHooks";

var db = getDatabase(Firebase);
var auth = getAuth(Firebase);
const moment = require('moment');
class FireFetch {

	SaveTODB(endPoint, objectID, object) {
		const path = "talmidsdb/" + endPoint + '/' + objectID;
		return set(ref(db, path), object)
			.then(() => {
				invalidateDemoData(path);
				return "success";
			})
			.catch((error) => {
				return error.getMessage;
			});
	};

	UpdateInDB(endPoint, objectID, object) {
		const path = "talmidsdb/" + endPoint + '/' + objectID;
		return update(ref(db, path), object)
			.then(() => {
				invalidateDemoData(path);
				return "success";
			})
			.catch((error) => {
				return error.getMessage;
			});
	};

	async DeleteFromDB(endPoint, objectID) {
		const path = "talmidsdb/" + endPoint + '/' + objectID;
		return await remove(ref(db, path))
			.then(() => {
				invalidateDemoData(path);
				return "success";
			})
			.catch((error) => {
				return error.getMessage;
			});
	};

	jsonToCsv(items) {
		const header = Object.keys(items[0]);
		const headerString = header.join(',');
		// handle null or undefined values here
		const replacer = (key, value) => value ?? '';
		const rowItems = items?.map((row) =>
			header
				.map((fieldName) => JSON.stringify(row[fieldName], replacer))
				.join(',')
		);
		// join header and body, and break into separate lines
		const csv = [headerString, ...rowItems].join('\r\n');
		return csv;
	}

	exportXL(tab, eventsData) {
		var table = tab;
		var exportData = table.getExportData();
		//console.log(exportData);
		if (eventsData !== undefined) {
			var dataObjects = eventsData;
			dataObjects?.map((item) => {
				delete item.action;
				delete item.status;
			})
			const csvData = this.jsonToCsv(eventsData)
			var csv = exportData.dataTable.csv;
			table.export2file(csvData, csv.mimeType, csv.filename, csv.fileExtension, csv.merges, csv.RTL, csv.sheetname);
		}
		else {
			console.error(
				"Unable to print due to some error"
			)
		}
	}

	randomInteger(min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	addLog(record, recordID, actionType) {
		onAuthStateChanged(auth, function (user) {
			if (user) {
				var timeStamp = moment().format("YYYY-MM-DDTh:mm:ss");
				var objectID = Array(12).fill("ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789abcdefghijklmnopqrstuvwxyz")
					.map(function (x) { return x[Math.floor(Math.random() * x.length)] }).join('');

				var logObject = {
					logID: objectID,
					timeStamp: timeStamp,
					record: record,
					recordID: recordID,
					actionType: actionType,
					id: user.uid
				}
				Object.entries(logObject).forEach(([key, value]) => {
					if (value === undefined) {
						logObject[key] = "";
					}
				});
				set(ref(db, "talmidsdb/logs/" + objectID), logObject)
					.then(() => {
						return "Success";
					})
					.catch((error) => {
						return "Error: " + error.message
					})
			}
		})
	}

	convertToJson(csv) {
		var lines = csv.split("\n");
		var result = [];
		var headers = lines[0].split(",");
		for (var i = 1; i < lines.length; i++) {
			var obj = {};
			var currentline = lines[i].split(",");
			for (var j = 0; j < headers.length; j++) {
				obj[headers[j]] = currentline[j];
			}
			result.push(obj);
		}
		//return result; //JavaScript object
		return result; //JSON
	}
}

export default new FireFetch();
